import Vue from 'vue';
import LoginBase from './base';
import LoginApp from './app';
const loginBaseHandler = new LoginBase();
const loginAppHandler = new LoginApp();
/**
 * 当游戏内，则返回通用msdk游戏插件，否则如果有业务插件方法，则返回业务插件，最后返回base插件
 * @param {*} Vue
 * @param {*} eventName
 * @returns
 */
function getHandler(Vue) {
  console.log('Vue.prototype.$ast.isAPP()=', Vue.prototype.$ast.isAPP());
  if (Vue.prototype.$ast.isAPP()) return loginAppHandler;

  return loginBaseHandler;
}

const originLoginFunc = {
  initLogin: async (params) => {
    console.info('supercore initLogin');
    return await getHandler(Vue, 'initLogin').initLogin(params);
  },
  checkLogin: async (params) => {
    console.info('supercore checkLogin');
    const loginRes = await getHandler(Vue, 'checkLogin').checkLogin(params);
    console.log('checkLogin return isLogin=', loginRes.isLogin, ' userInfo=', loginRes.userInfo);
    return loginRes;
  },
  login: async (params) => {
    console.info('supercore login');
    return await getHandler(Vue, 'login').login(params);
  },
  logout: async (params) => {
    console.info('supercore logout');
    return await getHandler(Vue, 'logout').logout(params);
  },
  checkRoleInfo: async (params) => {
    console.info('supercore checkRoleInfo');
    return await getHandler(Vue, 'checkRoleInfo').checkRoleInfo(params);
  },
};

const loginPlugin = {
  install(Vue) {
    Vue.prototype.$loginSupercorePlugin = {
      ...originLoginFunc,
    };
  },
};
export default loginPlugin;
export { originLoginFunc };
